import React from 'react';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot } from 'react-dom/client';

import './utils/logger';
import './index.css';
import { App } from './App/App';
import { DynamicBrowserRouter } from './App/DynamicBrowserRouter';
import { IwQueryClientProvider } from './store/IwQueryClientProvider';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <IwQueryClientProvider>
      <ReactQueryDevtools initialIsOpen={false} />
      <DynamicBrowserRouter>
        <App />
      </DynamicBrowserRouter>
    </IwQueryClientProvider>
  </React.StrictMode>,
);
